module.exports = __webpack_public_path__ + "img/marker-alt-primary.svg?2fae9c259b4e9ae865fe541953a2eaa9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maps/marker-alt-primary.svg
// module id = 302
// module chunks = 0